import { render, staticRenderFns } from "./trilha-layer.vue?vue&type=template&id=a882c46a"
import script from "./trilha-layer.vue?vue&type=script&lang=js"
export * from "./trilha-layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports